import React, { useState } from "react";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// import {Item} from "react-photoswipe-gallery"
import { Gallery } from "react-photoswipe-gallery";

import PortfolioDetailsTile from "./PortfolioDetailsTile";

const Portfolio = () => {
  const projectsInit = [
    {
      images: [
        "assets/img/portfolio/lerpr-top.png",
        "assets/img/portfolio/lerpr-2.png",
        "assets/img/portfolio/lerpr-3.png",
        "assets/img/portfolio/lerpr-4.png",
      ],
      title: "Lerpr",
      subtitle: "Front End Development",
      description: [
        'Pierre Bézier popularized a method for creating smooth curves with incredible flexibility that could be described mathematically using only a handful of coordinates. Since his work in the 1960s, so called Bézier Curves have been a staple tool in 3D modeling due to their simplicity and the graceful way they curve around their control points, although they are just one tool in the field of "splines"',
        "I was inspired to demonstrate the power of splines by allowing users to experience first-hand how the shape of a curve can generate a beautiful output. Lerpr allows you to directly modify the positions of spline anchors and control points, while the curve geometry is translated into a color gradient in real time.",
        "Lerpr was a team effort. Among other roles, I was responsible for the math that generates the color gradient, which works by sampling 100 points per curve segment and mapping the X-Y coordinates onto an interpolation between the user-defined color stops. In this proof of concept, the user is limited to cubic Bézier splines, but I would love to come back and extend the functionality to include higher order curves which can develop really wild shapes.",
      ],
      date: "Feb 22, 2023",
      host: "https://scottank.github.io/lerpr/",
      skills: "Linear Algebra, HTML5 Canvas",
      monolithRepo: "https://github.com/ScottAnk/lerpr",
    },
    {
      images: [
        "assets/img/portfolio/movie-royale-top.png",
        "assets/img/portfolio/movie-royale-2.png",
        "assets/img/portfolio/movie-royale-3.png",
        "assets/img/portfolio/movie-royale-4.png",
      ],
      title: "Movie Royale",
      subtitle: "Back End Development",
      description: [
        "Movie Royale eliminates the constant squalling and headaches that come from a movie night. Rather than scrolling through Netflix or another stream service, get ahead of the game by using Movie royale to quickly and effectively recommend and vote on your favorite movie! After creating an account, simply send the room code to your friends.",
        "When we created the idea for Movie Royale interacting with friends was the top feature, so we knew we needed a snappy interface that got right to business. First off, we ditched the typical user account generation in favor of room codes. As long as you have an account, all of your friends can join your room with a single short code (this is a unique ID in the database which is used in all the API calls to indicate where user updates should be applied). Secondly, we opted to add a websocket connection so the server can push updates to everyone in a room whenever another user votes on a movie.",
      ],
      date: "Mar 15, 2023",
      skills: "MongoDB, websocket",
      host: "https://movie-royale-app.onrender.com/",
      monolithRepo: "https://github.com/ScottAnk/movie-royale",
    },
    {
      images: [
        "assets/img/portfolio/game-tracker-top.png",
        "assets/img/portfolio/game-tracker-2.png",
        "assets/img/portfolio/game-tracker-3.png",
        "assets/img/portfolio/game-tracker-4.png",
      ],
      title: "Boardgame Tracker",
      subtitle: "Full Stack Development",
      description: [
        "Game Tracker is a quick way to make a digital copy of your boardgame collection (or whatever kinds of games you like, I won't tell). Accessible anywhere you go, this digital library of games is essential when planning boardgame nights and is an easy way to show off your collection to friends.",
        "I built this app as a demonstration of the basic CRUD actions of mongoDB. But the theme of the app is a direct result of my boardgame passion. Allocating resources, planning three turns ahead, scoping out just enough plans to fill out your limited actions, I won't pretend that boardgames can teach you everything about project management, but it's not an exaggeration to say that I've learned some important lessons from this hobby.",
      ],
      date: "Feb 22, 2023",
      host: "https://game-tracker-znto.onrender.com/",
      skills: "MongoDB, JSON Web Token",
      clientRepo: "https://github.com/ScottAnk/game-tracker-client",
      serverRepo: "https://github.com/ScottAnk/game-tracker-server",
    },
  ];
  projectsInit.forEach((project) => {
    project.modalState = false;
  });

  const [projects, setProjects] = useState(projectsInit);

  function toggleModal(key) {
    const newState = [...projects];
    newState[key].modalState = !newState[key].modalState;
    setProjects(newState);
  }

  return (
    <>
      <Gallery>
        <div className="container">
          <div className="tokyo_tm_portfolio">
            <div className="tokyo_tm_title">
              <div className="title_flex">
                <div className="left">
                  <span>Portfolio</span>
                  <h3>Development Portfolio</h3>
                </div>
              </div>
            </div>
            {/* END TOKYO_TM_TITLE */}

            <div className="portfolio_filter">
              {/* <Tabs>
                <TabList>
                  <Tab>Software</Tab>
                  <Tab>Photography</Tab>
                </TabList> */}
              {/* END TABLIST */}
              <div className="list_wrapper">
                {/* <TabPanel> */}
                <ul className="portfolio_list">
                  {projects.map((project, index) => (
                    <PortfolioDetailsTile
                      key={index}
                      project={project}
                      toggleModal={toggleModal}
                      projectKey={index}
                    />
                  ))}
                  {/* END DETAILS */}
                </ul>
                {/* END DETAILS GALLERY */}
                {/* </TabPanel> */}
                {/* END CREATIVE PORTFOLIO GALLERY */}
                {/* TODO place future photos here to separate tabs
                  <TabPanel>
                    <ul className="portfolio_list">
                      <li data-aos="fade-right" data-aos-duration="1200">
                        <div className="inner">
                          <div className="entry tokyo_tm_portfolio_animation_wrap">
                            <Item
                              original="assets/img/portfolio/4.jpg"
                              thumbnail="assets/img/portfolio/4.jpg"
                              width={500}
                              height={550}
                            >
                              {({ ref, open }) => (
                                <img
                                  src="assets/img/portfolio/4.jpg"
                                  alt="Childhood"
                                  data-tip
                                  data-for="shot"
                                  role="button"
                                  ref={ref}
                                  onClick={open}
                                />
                              )}
                            </Item>
                            <ReactTooltip
                              id="shot"
                              place="bottom"
                              type="light"
                              effect="float"
                              className="tooltip-wrapper"
                            >
                              <div>
                                <h5>Derek Smith</h5>
                                <span>Shot</span>
                              </div>
                            </ReactTooltip>
                          </div>
                        </div>
                      </li>
                      //END SHOT
                      <li
                        data-aos="fade-right"
                        data-aos-duration="1200"
                        data-aos-delay="100"
                      >
                        <div className="inner">
                          <div className="entry tokyo_tm_portfolio_animation_wrap">
                            <Item
                              original="assets/img/portfolio/3.jpg"
                              thumbnail="assets/img/portfolio/3.jpg"
                              width={500}
                              height={550}
                            >
                              {({ ref, open }) => (
                                <img
                                  src="assets/img/portfolio/3.jpg"
                                  alt="Childhood"
                                  data-tip
                                  data-for="shot"
                                  role="button"
                                  ref={ref}
                                  onClick={open}
                                />
                              )}
                            </Item>
                            <ReactTooltip
                              id="shot2"
                              place="bottom"
                              type="light"
                              effect="float"
                              className="tooltip-wrapper"
                            >
                              <div>
                                <h5>Gloria jenkins</h5>
                                <span>Shot</span>
                              </div>
                            </ReactTooltip>
                          </div>
                        </div>
                      </li>
                      // {/* END SHOT *
                    </ul>
                    // {/* END PORTFOLIO LIST *
                  </TabPanel> */}
                {/* END PHOTOGRAHY */}
              </div>
              {/* END LIST WRAPPER */}
              {/* </Tabs> */}
            </div>
          </div>
        </div>
      </Gallery>
    </>
  );
};

export default Portfolio;
